import { Form, Row, Col, Input, Select, Button } from "antd";
import { PhoneInput } from "../../../components/PhoneInput";
import { FullNameFormItems } from "./FullNameFormItems";
import { useGetEmailFormRules } from "../../../lib/hooks/getEmailFormRules";
import { useCreateAdmin } from "../hooks/useCreateAdmin";
import { IOption } from "../../../types/Option";
import { useFormattedRoles } from "../hooks/useFormattedRoles";
import { Rule } from "antd/es/form";
import { useCallback, useMemo } from "react";

type CreateAdminProps = {
  setShowSideBar: React.Dispatch<React.SetStateAction<boolean>>;
  roles: IOption[];
  reloadData: () => void;
};

export const CreateAdmin = ({
  setShowSideBar,
  roles,
  reloadData,
}: CreateAdminProps) => {
  const [form] = Form.useForm();

  const { rules: emailRules } = useGetEmailFormRules();

  const { isLoading, onSubmit } = useCreateAdmin(setShowSideBar, reloadData);

  const { formattedRoles } = useFormattedRoles(roles);

  const roleRules: Rule[] = useMemo(
    () => [
      {
        required: true,
        message: "Please select Role",
      },
    ],
    [],
  );

  const onFormSubmit = useCallback(
    (values: any) => onSubmit({ ...values, confirmAdditionalUser: false }),
    [onSubmit],
  );

  return (
    <>
      <div className="px-6 pt-8 pb-6 sidebar-body">
        <Form
          autoComplete="off"
          requiredMark={false}
          layout="vertical"
          form={form}
          onFinish={onFormSubmit}
          disabled={isLoading}
        >
          <FullNameFormItems />

          <Row className="align-center mb-4">
            <Col span={8}>
              <span className="text-md title">Email</span>
            </Col>
            <Col span={16}>
              <Form.Item name="email" className="mb-0" rules={emailRules}>
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row className="align-center mb-4">
            <Col span={8}>
              <span className="text-md title">Phone</span>
            </Col>
            <Col span={16}>
              <PhoneInput
                form={form}
                size="middle"
                formItemMargin="mb-0"
                disabled={isLoading}
                label=" "
              />
            </Col>
          </Row>

          <Row className="align-center mb-4">
            <Col span={8}>
              <span className="text-md title">Role</span>
            </Col>
            <Col span={16}>
              <Row>
                <Col span={14}>
                  <Form.Item name="roleId" className="mb-0" rules={roleRules}>
                    <Select options={formattedRoles} />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
      <div className="sidebar-footer px-6 py-6">
        <Button
          type="primary"
          shape="round"
          onClick={form.submit}
          disabled={isLoading}
          loading={isLoading}
        >
          Create Admin
        </Button>
      </div>
    </>
  );
};
